//66
export const interfaceEncryptionLists =
    [
        'nodes.speedtest.cn',
        'nodes-test.speedtest.cn',
        'nodes-pre.speedtest.cn',
        '/node',
        '/speedUp/query',
        '/speed/store',
        '/user/info',
        '/speedup/record',
        '/5g/station',
        '/speed/store',
        '/score/saveScore',
        '/speed/detail',
        'location/store',
        '/user/profile',
        '/speed/nearbySpeed',
        '/5g/hall',
        '/privateFile',
        '/api/v2/video/my-store',
        '/api/v2/video/store'
    ]

// 请求加密
export const interfaceEncryptionLists2 =
    [
        // 'nodes.speedtest.cn',
        // 'nodes-test.speedtest.cn',
        // 'nodes-pre.speedtest.cn',
        // '/node',
        'api-v3-ipv6.speedtest.cn',
    ]

//65
export const interfaceEncryptionLists3 =
    [
        'api-v3-ipv6.speedtest.cn',
    ]

//请求头不进行处理
export const interfaceEncryptionLists4 = ['nodes-api.speedtest.cn']



// WEBPACK FOOTER //
// ./resources/js/config/CLIENTECTYPE66.js